<template>
  <div class="flex items-center space-x-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="28.339" height="20.883" viewBox="0 0 46 34">
      <g id="visa-v2" transform="translate(-1 -7)">
        <rect
          id="Rectangle_616"
          data-name="Rectangle 616"
          width="46"
          height="34"
          rx="3"
          transform="translate(1 7)"
          fill="#1a1876"
        />
        <path id="Path_4576" data-name="Path 4576" d="M19.238,28.8h2.609l1.633-9.576H20.87Z" fill="#fff" />
        <path
          id="Path_4577"
          data-name="Path 4577"
          d="M28.743,23.069c-.912-.443-1.471-.739-1.465-1.187,0-.4.473-.824,1.5-.824a4.713,4.713,0,0,1,2.187.477l.354-2.075a6.745,6.745,0,0,0-2.34-.4c-2.579,0-4.4,1.3-4.411,3.16-.014,1.376,1.3,2.144,2.287,2.6,1.016.469,1.358.768,1.353,1.187-.007.642-.811.936-1.562.936a5.715,5.715,0,0,1-2.793-.655l-.366,2.143a8.244,8.244,0,0,0,2.907.511c2.744,0,4.525-1.284,4.545-3.271C30.944,24.581,30.249,23.752,28.743,23.069Z"
          fill="#fff"
        />
        <path
          id="Path_4578"
          data-name="Path 4578"
          d="M38.007,19.233H35.99a1.3,1.3,0,0,0-1.367.794L30.747,28.8h2.741s.448-1.18.549-1.439H37.38c.078.336.318,1.435.318,1.435H40.12Zm-3.218,6.173c.108-.277,1.173-3.012,1.386-3.591.352,1.65.009.049.78,3.591Z"
          fill="#fff"
        />
        <path
          id="Path_4579"
          data-name="Path 4579"
          d="M17.049,19.231l-2.556,6.53-.272-1.327-.915-4.4a1.093,1.093,0,0,0-1.184-.809H7.913l-.033.2a10.964,10.964,0,0,1,2.742,1.051l2.32,8.317H15.7l4.109-9.558Z"
          fill="#fff"
        />
      </g>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" width="28.339" height="20.883" viewBox="0 0 46 34">
      <g id="mastercard" transform="translate(-1 -7)">
        <rect
          id="Rectangle_617"
          data-name="Rectangle 617"
          width="46"
          height="34"
          rx="3"
          transform="translate(1 7)"
          fill="#243747"
        />
        <circle
          id="Ellipse_119"
          data-name="Ellipse 119"
          cx="8"
          cy="8"
          r="8"
          transform="translate(11 16)"
          fill="#e61c24"
        />
        <circle
          id="Ellipse_120"
          data-name="Ellipse 120"
          cx="8"
          cy="8"
          r="8"
          transform="translate(20.934 16)"
          fill="#f99f1b"
        />
        <path
          id="Path_4585"
          data-name="Path 4585"
          d="M23.967,17.736h0a7.985,7.985,0,0,0,0,12.528h0a7.985,7.985,0,0,0,0-12.528Z"
          fill="#f26622"
        />
      </g>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" width="28.339" height="20.883" viewBox="0 0 46 34">
      <g id="amex" transform="translate(-1 -7)">
        <path
          id="Path_4580"
          data-name="Path 4580"
          d="M44,7H4a3,3,0,0,0-3,3V38a3,3,0,0,0,3,3H44a3,3,0,0,0,3-3V10A3,3,0,0,0,44,7Z"
          fill="#007ac6"
        />
        <path
          id="Path_4581"
          data-name="Path 4581"
          d="M10.533,24.429h2.33L11.7,21.572ZM43,19H37.031l-1.456,1.571L34.264,19H21.6l-1.165,2.571L19.268,19h-5.1v1.143L13.59,19H9.222L5,29h5.1l.582-1.571h1.456L12.716,29h5.678V27.857L18.831,29h2.912l.437-1.286V29H33.828l1.456-1.571L36.594,29h5.969l-3.785-5ZM25.383,27.571h-1.6V22l-2.475,5.571H19.85L17.375,22v5.571H14.026L13.444,26H9.95l-.582,1.571H7.475l3.057-7.143h2.475l2.766,6.714V20.428h2.766l2.184,4.857,2.038-4.857h2.766v7.143Zm14.414,0H37.613L35.72,25.142l-2.184,2.429H26.984V20.428h6.7l2.038,2.286L37.9,20.428h2.038L36.739,24ZM28.586,21.857v1.286h3.64v1.429h-3.64V26h4.077l1.893-2.143-1.747-2Z"
          fill="#fff"
        />
      </g>
    </svg>
  </div>
</template>
